import { Button, ButtonProps } from '@chakra-ui/react';

type CustomButtonProps = ButtonProps & {
  text: string;
};

const CustomButton = (props: CustomButtonProps): JSX.Element => {
  const { text, ...rest } = props;
  return (
    <Button
      borderRadius="20px"
      bg="custom.levoBlue"
      color="white"
      fontFamily="Lato"
      fontWeight={700}
      fontSize={16}
      disabled={rest.disabled}
      isLoading={rest.isLoading}
      {...rest}
    >
      {text}
    </Button>
  );
};

export default CustomButton;
